// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"ea5512a9","453":"ef582e97","724":"6beeda74","871":"146caf73","876":"34f55472"}[chunkId] + ".chunk.js";
};